import React from 'react';
import Modal from 'react-modal';

const DisplaySolutionPopupContent = (props) => {
  const body = document.getElementsByTagName('body')[0];

  const isTextShow = i18n.locale === 'ru';

  return (
    <Modal isOpen={props.openModal} appElement={body} shouldCloseOnOverlayClick={true} onRequestClose={props.closeModal} contentLabel={i18n.t('solving_display_problems.button_name')} className="display-solution-popup__modal" overlayClassName="display-solution-popup">
      <button className="close display-solution-popup__close-btn" onClick={props.closeModal}>
        <span>×</span>
      </button>
      <div className="display-solution-popup__wrapper">
        <div className="display-solution-popup__header">
          <h2 className="display-solution-popup__title">{i18n.t('solving_display_problems.title')}</h2>
        </div>
        <div className="display-solution-popup__content">
          <p className="display-solution-popup__text">{i18n.t('solving_display_problems.paragraph_1')}</p>
          <p className="display-solution-popup__text">{i18n.t('solving_display_problems.paragraph_2')}</p>
          {isTextShow && <p className="display-solution-popup__text">{i18n.t('solving_display_problems.paragraph_3')}</p>}
          {isTextShow && <p className="display-solution-popup__text">{i18n.t('solving_display_problems.paragraph_4')}</p>}
        </div>
      </div>
    </Modal>
  );
};

export default DisplaySolutionPopupContent;
